import React, { useState, useEffect } from 'react'
import useBreadcrumbs, { BreadcrumbsRoute } from 'use-react-router-breadcrumbs'
import { useLocation, useNavigate } from 'react-router'

import { getHubRoutes } from './hubRoutesRegistry'
import { semanthicPathsBreadcrumbIgnore } from './constants'
import { BreadcrumbUI, PAGE_TREE_ROOT } from './UI'
import { BreadcrumbContainer } from './UI/style'
import { filterBreadcrumbs, isBreadcrumbEnabled, IBreadcrumbLink } from './behavior'

export interface IRouteProps {
  path: string
  name: string
}

const useHubBreadcrumbs = (): { filteredBreadcrumbs: IBreadcrumbLink[], refreshKey: number } => {
  const breadcrumbs = useBreadcrumbs(getHubRoutes() as unknown as BreadcrumbsRoute[], { excludePaths: semanthicPathsBreadcrumbIgnore })
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    const handleTrackNameChange = () => {
      setRefreshKey(prev => prev + 1)
    }

    window.addEventListener('trackNameChanged', handleTrackNameChange)
    return () => window.removeEventListener('trackNameChanged', handleTrackNameChange)
  }, [])

  return { filteredBreadcrumbs: filterBreadcrumbs(breadcrumbs), refreshKey }
}

export const Breadcrumb = (): React.ReactElement => {
  const navigate = useNavigate()
  const { filteredBreadcrumbs, refreshKey } = useHubBreadcrumbs()

  return (
    <>
      <BreadcrumbUI key={refreshKey} filteredBreadcrumbs={filteredBreadcrumbs} navigate={navigate} />
    </>
  )
}

export const BreadcrumbSection = (): React.ReactElement | null => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { filteredBreadcrumbs, refreshKey } = useHubBreadcrumbs()

  if (!isBreadcrumbEnabled(pathname) || filteredBreadcrumbs.length <= PAGE_TREE_ROOT) return null

  return (
    <BreadcrumbContainer>
      <BreadcrumbUI key={refreshKey} filteredBreadcrumbs={filteredBreadcrumbs} navigate={navigate} />
    </BreadcrumbContainer>
  )
}
